module.exports = __webpack_public_path__ + "static/ai-28ebdac024bb366467ee9d407a91c9dd.svg";